import { useState, useRef, useContext, useEffect } from 'react';
import './index.css';
import { StoreContext } from '../../store';

import emailjs from '@emailjs/browser';

import Show from '../../utility/Show';
import FormError from '../../utility/FormError';
import Survey from './survey';

import { ReactComponent as WalkspanLogo } from '../../assets/walkspan-logo-2.svg';
import { ReactComponent as Info } from '../../assets/alert-icon.svg';

import { isValidEmail } from '../../services';
import SubscriptionPlans from './SubscriptionPlans';

const ReachedLimit = () => {
  const { state, dispatch, actions, navigate } = useContext(StoreContext);
  const { errorMessage, isMobile, userDetails } = state;

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [email, setEmail] = useState('');
  const [surveyError, setSurveyError] = useState('');
  const formRef = useRef();

  const sendEmail = (event) => {
    event.preventDefault();
    actions.clearErrorMessage();
    const email = formRef?.current[0]?.value;

    if (email === '') {
      dispatch({
        type: 'SET_ERROR_MESSAGE',
        payload: 'Email is required.',
      });
      return;
    }

    if (!isValidEmail(email)) {
      dispatch({
        type: 'SET_ERROR_MESSAGE',
        payload: 'Please enter a valid email.',
      });
      return;
    }

    emailjs
      .sendForm(
        'service_tdyc8vd',
        'template_npenggs',
        formRef.current,
        'NqktzMSE3ylSjOrfR'
      )
      .then(
        (result) => {
          setIsSubmitted(true);
        },
        (error) => {
          setIsSubmitted(false);
        }
      );
  };

  const handleSurvey = (value) => {
    setShowSurvey(value);
  };

  const openPrivacyPolicy = () => {
    dispatch({ type: 'SET_SHOW_PRIVACY_POLICY', payload: true });
  };

  useEffect(() => {
    document.title = 'Walkspan | Reached Limit';
  }, []);

  return (
    <div
      className={`reached-limit-container ${
        isMobile && isSubmitted ? 'vertically-centered' : ''
      }`}
    >
      <Show>
        <Show.When isTrue={showSurvey}>
          <Survey
            navigate={navigate}
            actions={actions}
            handleSurvey={handleSurvey}
          />
        </Show.When>
        <Show.Else>
          <div className='reached-limit-card h-full w-full'>
            <WalkspanLogo className='logo' />
            <div className='reached-limit-header'>
              <Show>
                <Show.When isTrue={isSubmitted}>
                  <h1 className='title'>Thank you for your request!</h1>
                  <span>Our team will reach out to you shortly.</span>
                </Show.When>
                <Show.Else>
                  <h1 className='title'>
                    You've reached your limit
                  </h1>
                  <span className='text-sm text-gray'>
                    Upgrade to other plan to continue
                  </span>
                </Show.Else>
              </Show>
            </div>

            <SubscriptionPlans userDetails={userDetails} state={state} />
          </div>
        </Show.Else>
      </Show>
    </div>
  );
};

export default ReachedLimit;